import { styled, Button, Box, ButtonProps } from '@mui/material';
import { colorMap } from 'assets/themes/zizzi/colorMap';

export const StyledButton = styled(Button)``;

export const StyledBox = styled(Box)`
  border-bottom: 2px solid ${({ color }: ButtonProps) => color && colorMap[color]};
  font-weight: 700;
`;
